module.exports = __webpack_public_path__ + "img/jumpilla-6.c323ae78.jpg";